import axios from 'axios';
import { API_BASE_URL } from '../config/endpoints.js';
import { generateRequestId } from '../observability/requestId.js';
import { logInfo, logError } from '../observability/logger.js';

const API_URL = `${API_BASE_URL}/api/token`;

const login = async (username, password) => {
  if (!username || !password) {
    throw new Error('Username e password são obrigatórios');
  }

  try {
    const requestId = generateRequestId('login');
    logInfo('auth.login.request', {
      request_id: requestId,
      username_present: Boolean(username),
    });

    const response = await axios.post(
      `${API_URL}/auth`,
      { username, password },
      { headers: { 'X-Request-ID': requestId } }
    );

    if (response.status === 200 && response.data.access_token) {
      logInfo('auth.login.success', {
        request_id: response.headers['x-request-id'] || requestId,
      });
      return {
        access_token: response.data.access_token,
        refresh_token: response.data.refresh_token,
      };
    } else {
      logError('auth.login.unexpected_response', {
        request_id: response.headers['x-request-id'] || requestId,
        status: response.status,
      });
      throw new Error('Erro inesperado ao fazer login. Por favor, tente novamente.');
    }
  } catch (error) {
    if (error.response) {
      logError('auth.login.failed_response', {
        request_id: error.response.headers?.['x-request-id'],
        status: error.response.status,
        message: error.response.data?.message || error.response.statusText,
      });
      throw new Error(`Erro ao fazer login: ${error.response.data.message || error.response.statusText}`);
    } else if (error.request) {
      logError('auth.login.no_response', {
        message: 'Nenhuma resposta do servidor',
      });
      throw new Error('Erro ao fazer login: Nenhuma resposta do servidor. Por favor, verifique sua conexão de internet.');
    } else {
      logError('auth.login.request_setup_error', {
        message: error.message,
      });
      throw new Error(`Erro ao fazer login: ${error.message}`);
    }
  }
};

const refreshAuthToken = async (refreshToken) => {
  if (!refreshToken) {
    throw new Error('Refresh token ausente');
  }

  const requestId = generateRequestId('refresh');
  const response = await axios.post(
    `${API_URL}/refresh`,
    { refresh_token: refreshToken },
    { headers: { 'X-Request-ID': requestId } }
  );

  if (response.status !== 200 || !response.data.access_token) {
    throw new Error('Falha ao renovar token');
  }

  return {
    access_token: response.data.access_token,
    refresh_token: response.data.refresh_token,
  };
};

export { login, refreshAuthToken };
